export default {
	BACKSPACE: 8,
	TAB: 9,
	RETURN: 13,
	ENTER: 13,
	CTRL: 17,
	ALT: 18,
	ESC: 27,
	ESCAPE: 27,
	SPACE: 32,
	PAGE_UP: 33,
	PAGE_DOWN: 34,
	END: 35,
	HOME: 36,
	LEFT: 37,
	UP: 38,
	RIGHT: 39,
	DOWN: 40,
	DELETE: 46,
	SHIFT: 16
}
